import { useQuery } from '@tanstack/react-query'
import { listMembers } from '@/api/members'

export interface HouseholdMember {
  id: string
  name: string
}

/** Household members (registered users + tracked non-earning people) as a flat
 *  { id, name } list — the shape both the owner picker and the owner display need. */
export function useHouseholdMembers(): HouseholdMember[] {
  const { data } = useQuery({ queryKey: ['members'], queryFn: () => listMembers() })
  return [
    ...(data?.users.map((u) => ({ id: u.id, name: u.displayName ?? u.email })) ?? []),
    ...(data?.trackedPeople.map((p) => ({ id: p.id, name: p.name })) ?? []),
  ]
}
